module.exports = __webpack_public_path__ + "img/try_1.588ab635.png";